module.exports = __webpack_public_path__ + "media/scan_success.8f6bf16b.wav";